module.exports = __webpack_public_path__ + "static/img/gx.c9b59fbf.png";